export class SessionStartupOrchestrator {
    constructor(tasks = []) {
        this.tasks = tasks
    }

    async run(context) {
        console.log('SessionStartupOrchestrator: Running startup tasks...')
        for (const task of this.tasks) {
            try {
                await task.run(context)
            }
            catch (error) {
                console.error(`SessionStartupOrchestrator: Task ${task.name || 'unknown'} failed:`, error)
            }
        }
        console.log('SessionStartupOrchestrator: All startup tasks completed.')
    }
}
